import { render, staticRenderFns } from "./customerInformationForm.vue?vue&type=template&id=406fc164&scoped=true"
import script from "./customerInformationForm.vue?vue&type=script&lang=ts"
export * from "./customerInformationForm.vue?vue&type=script&lang=ts"
import style0 from "./customerInformationForm.vue?vue&type=style&index=0&id=406fc164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406fc164",
  null
  
)

export default component.exports